module.exports = __webpack_public_path__ + "img/Icon-Chat-white.889a0848.svg";